import script from "./p10-report.vue?vue&type=script&setup=true&lang=js"
export * from "./p10-report.vue?vue&type=script&setup=true&lang=js"

import "./p10-report.vue?vue&type=style&index=0&id=647d3390&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647d3390"]])

export default __exports__